import Vue from 'vue';
import { timeFormatte, addUnit, emptyImage } from '@/common/utils/ways';
import { suffix } from '@/common/utils/image';
// 缩略图
Vue.filter('thumbnail', suffix);
// 时间格式化  2020-10-20 => 2020.10.10
Vue.filter('timeFormatte', timeFormatte);
Vue.filter('addUnit', addUnit);
Vue.filter('emptyImage', emptyImage);
